import React, { useState, useEffect } from 'react';
import ewasteBinImg from '../../assets/images/E-Waste-bin.png';
import './EWasteBinAnimation.css';

// SVG electronic icons for falling animation
const E_WASTE_ITEMS = [
  {
    id: 'phone',
    svg: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <rect x="5" y="2" width="14" height="20" rx="3" fill="#37474f" />
        <rect x="7" y="4" width="10" height="15" rx="1" fill="#81d4fa" />
        <circle cx="12" cy="20.5" r="1" fill="#cfd8dc" />
      </svg>
    ),
  },
  {
    id: 'keyboard',
    svg: (
      <svg viewBox="0 0 28 18" fill="currentColor" width="20" height="14">
        <rect x="1" y="2" width="26" height="14" rx="2" fill="#455a64" stroke="#263238" strokeWidth="1" />
        <rect x="3" y="4" width="3" height="2" fill="#cfd8dc" />
        <rect x="7" y="4" width="3" height="2" fill="#cfd8dc" />
        <rect x="11" y="4" width="3" height="2" fill="#cfd8dc" />
        <rect x="15" y="4" width="3" height="2" fill="#cfd8dc" />
        <rect x="19" y="4" width="3" height="2" fill="#cfd8dc" />
        <rect x="23" y="4" width="2" height="2" fill="#ffb74d" />
        <rect x="3" y="7" width="3" height="2" fill="#cfd8dc" />
        <rect x="7" y="7" width="3" height="2" fill="#cfd8dc" />
        <rect x="11" y="7" width="3" height="2" fill="#cfd8dc" />
        <rect x="15" y="7" width="3" height="2" fill="#cfd8dc" />
        <rect x="19" y="7" width="6" height="2" fill="#81c784" />
        <rect x="6" y="10" width="12" height="2" fill="#b0bec5" />
      </svg>
    ),
  },
  {
    id: 'mouse',
    svg: (
      <svg viewBox="0 0 16 22" fill="currentColor" width="14" height="18">
        <path d="M8 1 C4 1, 2 4, 2 9 L2 13 C2 18, 4 21, 8 21 C12 21, 14 18, 14 13 L14 9 C14 4, 12 1, 8 1 Z" fill="#37474f" />
        <line x1="8" y1="2" x2="8" y2="9" stroke="#90a4ae" strokeWidth="1" />
        <rect x="7" y="4" width="2" height="4" rx="1" fill="#4caf50" />
      </svg>
    ),
  },
  {
    id: 'chip',
    svg: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
        <rect x="4" y="4" width="12" height="12" rx="1" fill="#1b5e20" stroke="#81c784" strokeWidth="0.8" />
        <rect x="7" y="7" width="6" height="6" fill="#ffd54f" />
        <line x1="2" y1="6" x2="4" y2="6" stroke="#c8e6c9" strokeWidth="1.2" />
        <line x1="2" y1="10" x2="4" y2="10" stroke="#c8e6c9" strokeWidth="1.2" />
        <line x1="2" y1="14" x2="4" y2="14" stroke="#c8e6c9" strokeWidth="1.2" />
        <line x1="16" y1="6" x2="18" y2="6" stroke="#c8e6c9" strokeWidth="1.2" />
        <line x1="16" y1="10" x2="18" y2="10" stroke="#c8e6c9" strokeWidth="1.2" />
        <line x1="16" y1="14" x2="18" y2="14" stroke="#c8e6c9" strokeWidth="1.2" />
      </svg>
    ),
  },
  {
    id: 'battery',
    svg: (
      <svg viewBox="0 0 14 22" fill="currentColor" width="12" height="17">
        <rect x="4" y="1" width="6" height="2" rx="1" fill="#78909c" />
        <rect x="2" y="3" width="10" height="18" rx="2" fill="#263238" stroke="#4caf50" strokeWidth="1" />
        <rect x="3.5" y="7" width="7" height="12" rx="1" fill="#66bb6a" />
        <path d="M7 9 L5 13 L7 13 L6 16 L9 12 L7 12 Z" fill="#ffffff" />
      </svg>
    ),
  },
  {
    id: 'plug',
    svg: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
        <line x1="6" y1="2" x2="6" y2="6" stroke="#78909c" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="14" y1="2" x2="14" y2="6" stroke="#78909c" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="3" y="6" width="14" height="8" rx="2" fill="#37474f" />
        <path d="M10 14 Q10 18, 16 19" stroke="#263238" strokeWidth="2" fill="none" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'headphones',
    svg: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
        <path d="M3 11 C3 6, 7 3, 10 3 C13 3, 17 6, 17 11" stroke="#37474f" strokeWidth="2" fill="none" strokeLinecap="round" />
        <rect x="2" y="10" width="3" height="7" rx="1.5" fill="#43a047" />
        <rect x="15" y="10" width="3" height="7" rx="1.5" fill="#43a047" />
      </svg>
    ),
  },
];

export default function EWasteBinAnimation() {
  // Animation cycle: 0 -> 1 -> 2 -> 3 -> 4 (Full) -> Pause -> Reset
  const [fillLevel, setFillLevel] = useState(0);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // 12-second total loop
    // 0s-2s: level 0 (empty)
    // 2s-4s: level 1 (25%)
    // 4s-6s: level 2 (50%)
    // 6s-8s: level 3 (75%)
    // 8s-11.5s: level 4 (100% full with pulse)
    // 12s: reset to 0
    let currentStep = 0;
    const interval = setInterval(() => {
      currentStep = (currentStep + 1) % 6;
      if (currentStep === 0) {
        setFillLevel(0);
      } else if (currentStep === 1) {
        setFillLevel(1);
        triggerEcoSparkle();
      } else if (currentStep === 2) {
        setFillLevel(2);
        triggerEcoSparkle();
      } else if (currentStep === 3) {
        setFillLevel(3);
        triggerEcoSparkle();
      } else if (currentStep === 4) {
        setFillLevel(4);
        triggerEcoSparkle(true);
      } else if (currentStep === 5) {
        // Hold full state before restarting
        setFillLevel(4);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const triggerEcoSparkle = (isFull = false) => {
    const count = isFull ? 5 : 2;
    const newSparks = Array.from({ length: count }, (_, i) => ({
      id: Date.now() + i,
      x: 35 + Math.random() * 40,
      y: 20 + Math.random() * 20,
      size: 6 + Math.random() * 6,
      icon: i % 2 === 0 ? '✨' : '♻️',
    }));
    setParticles((prev) => [...prev.slice(-6), ...newSparks]);
    setTimeout(() => {
      setParticles((prev) => prev.filter((p) => !newSparks.some((s) => s.id === p.id)));
    }, 1200);
  };

  // Calculate clip inset percentage for electronics pile build-up
  // Level 0: 36% inset (only green bin visible)
  // Level 1: 27% inset
  // Level 2: 18% inset
  // Level 3: 9% inset
  // Level 4: 0% inset (fully overflowing e-waste bin)
  const pileClipTop = Math.max(0, 36 - fillLevel * 9);

  return (
    <div className="ewaste-anim-wrapper" title="E-Waste Collection Drive Live Progress">
      {/* Floating incoming electronic items */}
      <div className="ewaste-falling-items-layer">
        {E_WASTE_ITEMS.map((item, idx) => (
          <div
            key={item.id}
            className={`ewaste-falling-item item-${idx}`}
            style={{
              animationDelay: `${idx * 1.5}s`,
            }}
          >
            {item.svg}
          </div>
        ))}
      </div>

      {/* Sparkle Particles */}
      <div className="ewaste-particles-layer">
        {particles.map((spark) => (
          <span
            key={spark.id}
            className="ewaste-sparkle-dot"
            style={{
              left: `${spark.x}%`,
              top: `${spark.y}%`,
              fontSize: `${spark.size}px`,
            }}
          >
            {spark.icon}
          </span>
        ))}
      </div>

      {/* The E-Waste Bin Base Container & Dynamic Pile Build-Up */}
      <div className={`ewaste-bin-stack ${fillLevel === 4 ? 'is-full-pulse' : ''}`}>
        {/* Layer 1: Empty Green Bin Base (Lower 64% always visible) */}
        <div className="ewaste-bin-empty-base">
          <img
            src={ewasteBinImg}
            alt="E-Waste Collection Bin"
            className="ewaste-bin-render"
            style={{
              clipPath: 'inset(36% 0 0 0)',
            }}
          />
        </div>

        {/* Layer 2: Animated Rising Waste Pile */}
        <div
          className="ewaste-bin-pile-layer"
          style={{
            clipPath: `inset(${pileClipTop}% 0 0 0)`,
            transition: 'clip-path 0.9s cubic-bezier(0.34, 1.56, 0.64, 1)',
          }}
        >
          <img
            src={ewasteBinImg}
            alt="E-Waste Collected Items"
            className="ewaste-bin-render"
          />
        </div>
      </div>
    </div>
  );
}
